import React, { useState, useEffect } from "react";
import { Avatar_02 } from "../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import EssFullWidthModal from "components/modelpopup/baseModal"
import { Button } from "components/Button";
import { Controller } from "react-hook-form";
import {  useSelector } from 'react-redux';
import FilterSelect from "components/Form/filterSelect";
import { createAddressApi, updateAddressApi } from "api/services/employee";
import {  toast, Bounce } from 'react-toastify';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Use Bootstrap styles



const PersonalInformationModelPopup = ({
    addressModal,
    setAddressModal,
    selectedAddress,
    userData,
    fetchAddresses,
    setSelectedAddress

}) => {
 
  const [loading, setLoading]=  useState(false);



  const [nationalityOption, setNationalityOption] = useState([]);

  
  const { nationality, nationalityLoading } = useSelector(
    (state) => state.common
  );

  useEffect(() => {
    let _nationality = nationality.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });

    setNationalityOption(_nationality);
  }, [nationality]);





// ✅ Yup Validation Schema
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  address_1: yup.string().required("Address 1 is required"),
  address_2: yup.string(),

  city: yup.string().required("City is required"),
  country: yup.object().required("Country is required"),
  emergency_contact_name: yup.string(),
  // .required("Emergency Contact Name is required"),
  emergency_contact_number: yup.string(),
    // .required("Emergency Contact Number is required")
    // .min(8, "Contact number must be at least 8 digits")
    // .max(25, "Contact number must not exceed 15 digits"),
  emergency_contact_number_2: yup.string()
    .required("Home Contact Number  is required")
    .min(8, "Contact number must be at least 8 digits")
    .max(25, "Contact number must not exceed 15 digits"),
});

const {
  register,
  handleSubmit,
  formState: { errors },
  reset,
  control,
  setError,
  setValue
} = useForm({
  resolver: yupResolver(schema), // ✅ Apply Yup validation
  defaultValues:{

  }
});


useEffect(()=>{
  if(addressModal && selectedAddress?.id){
    setValue("name", selectedAddress?.name)
    setValue("address_1", selectedAddress?.address_1)

    setValue("address_2", selectedAddress?.address_2)

    setValue("city", selectedAddress?.city)

    setValue("emergency_contact_name", selectedAddress?.emergency_contact_name || "")
    setValue("emergency_contact_number", selectedAddress?.emergency_contact_number || "")
    setValue("emergency_contact_number_2", selectedAddress?.emergency_contact_number_2 || "")

    setValue("country", nationalityOption.find(item=> item.value==selectedAddress?.country?.id ))

  }
  

}, [addressModal, selectedAddress, nationalityOption])


const handleReset = () => {
  // reset({
  //   name: "",
  //   address_1: "",
  //   address_2: "",
  //   city: "",
  //   country: "",
  //   emergency_contact_name: "",
  //   emergency_contact_number: "",
  // });
  reset();
  setSelectedAddress("")
};

  const onSubmit = async (data) => {
    console.log(data)
    let payload = {
      ...data,
      country: data?.country?.value,
      company_user: userData?.id
    }
    if(data?.emergency_contact_number_2){
      payload.emergency_contact_number_2 = data?.emergency_contact_number_2.replace(/[+\s-]/g, "")
    }

    if(data?.emergency_contact_number){
      payload.emergency_contact_number = data?.emergency_contact_number.replace(/[+\s-]/g, "")
    }
    if(selectedAddress?.id){
      updateAddressData(payload)
    }else{
      createAddressData(payload)
    }
 

  };
  const updateAddressData = (payload) => {
    setLoading(true)
    updateAddressApi(selectedAddress?.id,payload).then(response=>{

      setAddressModal(false)
      setLoading(false)
      handleReset()
      toast.success('Emergency contact updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchAddresses()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating address!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 
  const createAddressData = (payload) => {
    setLoading(true)
    createAddressApi(payload).then(response=>{

      setAddressModal(false)
      setLoading(false)
      handleReset()
      toast.success('Emergency contact created!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchAddresses()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error creating address!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 

  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedAddress ? "Update Address" : "Create Address"}
        // style={{ top: 100 }}
        open={addressModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
            setAddressModal(false)
            handleReset()
        
        }}
        className="full-width-modal"
     >
        <div className="modal-content">
            
            <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                {/* 🔹 Name (Full width on mobile, Half on Desktop) */}
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Name</label>
                  <input type="text" placeholder="" className="form-control" {...register("name")} />
                  {errors.name && <small className="text-danger">{errors.name.message}</small>}
                </div>
              </div>

              <div className="row">
                {/* 🔹 Address 1 & Address 2 in the same row (Each Half on Desktop) */}
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Address 1</label>
                  <input type="text" className="form-control" {...register("address_1")} />
                  {errors.address_1 && <small className="text-danger">{errors.address_1.message}</small>}
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Address 2</label>
                  <input type="text" className="form-control" {...register("address_2")} />
                  {errors.address_2 && <small className="text-danger">{errors.address_2.message}</small>}

                </div>
              </div>

              <div className="row">
                {/* 🔹 City & Country in the same row (Each Half on Desktop) */}
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">City</label>
                  <input type="text" className="form-control" {...register("city")} />
                  {errors.city && <small className="text-danger">{errors.city.message}</small>}
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Country</label>
                  <Controller
                    name={`country`}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <FilterSelect
                        {...register("country")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={nationalityOption}
                        isLoading={nationalityLoading}
                        value={value}
                        placeholder={"Country"}
                      />
                    )}
                  />
                  {errors.country && <small className="text-danger">{errors.country.message}</small>}
                </div>
              </div>

             

<div className="row" >
<div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Emergency Home Contact Number</label>
                  {/* <input type="text" className="form-control" {...register("emergency_contact_number")} /> */}
                  <Controller
                    name="emergency_contact_number_2"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      minLength: {
                        value: 8,
                        message: "Enter a valid phone number",
                      },
                    }}
                    render={({field: {name, value, onChange, ref, onBlur}}) => {
                      // console.log(field, "LLL")
                      return(
                      <PhoneInput
                        value={value}
                        onChange={(value, country, event, formattedValue) => {
                          onChange(formattedValue);
                        }}
                        onBlur={onBlur} 
                        country={userData?.nationality?.iso.toLowerCase() || "ae"} // Default country
                        enableSearch={true}
                        inputClass="form-control w-100" // Bootstrap input class
                        placeholder="Home Contact Number"
                        // value={""}
                        inputProps={{
                          autoFocus: false,
                          countryCodeEditable: false,
                          name,
                          ref
                        }}
                      />
                    )}}
                  />
                  {errors.emergency_contact_number_2 && <small className="text-danger">{errors.emergency_contact_number_2.message}</small>}
                </div>
</div>
<hr/>


<div className="row">
                {/* 🔹 Emergency Contact Name & Number in the same row */}
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Emergency Local Contact Name</label>
                  <input type="text" className="form-control" {...register("emergency_contact_name")} />
                  {errors.emergency_contact_name && <small className="text-danger">{errors.emergency_contact_name.message}</small>}
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label">Emergency Local Contact Number</label>
                  {/* <input type="text" className="form-control" {...register("emergency_contact_number")} /> */}
                  <Controller
                    name="emergency_contact_number"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      minLength: {
                        value: 8,
                        message: "Enter a valid phone number",
                      },
                    }}
                    render={({field: {name, value, onChange, ref, onBlur}}) => (
                      <PhoneInput
                      value={value}
                      onChange={(value, country, event, formattedValue) => {
                          onChange(formattedValue);
                      }}
                      onBlur={onBlur}

                        country={"ae"} // Default country
                        enableSearch={true}
                        inputClass="form-control w-100" // Bootstrap input class
                        placeholder=" Contact Number"
                        // ref={ref} // Explicitly pass ref

                        inputProps={{
                          autoFocus: false,
                          countryCodeEditable: false,
                          name,
                          ref
                      }}
                      />
                    )}
                  />
                  {errors.emergency_contact_number && <small className="text-danger">{errors.emergency_contact_number.message}</small>}
                </div>
              </div>

              {/* 🔹 Submit Button */}
              <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
            </form>
            </div>
          </div>
     </EssFullWidthModal>

    

    </>
  );
};

export default PersonalInformationModelPopup;
